export const DeviceSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33329 16.6667V11.6667H11.6666V16.6667H15.8333V10H18.3333L9.99996 2.5L1.66663 10H4.16663V16.6667H8.33329Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
